// removed by extract-text-webpack-plugin
module.exports = {"tsp-disclaimer":"tsp-disclaimer___1j8bW center___2iqBf","tsp-disclaimer-icon":"tsp-disclaimer-icon___10ahc h1___3_4RF","tsp-index-link":"tsp-index-link___3vCrB"};